export const WEBSITE = {
    DOMAIN: 'www.idguardllc.com'
}